<div class="app-modal-backdrop">
  <dialog class="app-modal manage-meter-modal" open>
    <div class="manage-generator-modal__header">
      <h3 class="app-title-serif">Add New Meter</h3>
      <button type="button" class="app-button app-button--icon manage-generator-modal__close" (click)="closed.emit()">×</button>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="manage-generator-modal__body">
        <section class="app-form-error" *ngIf="error">{{ error }}</section>
        <div class="manage-generator-modal__grid">
          <label class="app-form-field" for="meter-add-generator">
            <span class="app-form-label">Generator</span>
            <p-autocomplete [inputId]="'meter-add-generator'" [(ngModel)]="selectedName" [ngModelOptions]="{ standalone: true }" [dropdown]="true" [suggestions]="suggestions" placeholder="Search generator" (completeMethod)="search($event)"></p-autocomplete>
          </label>
          <label class="app-form-field" for="meter-add-number">
            <span class="app-form-label">Meter Number <span class="meter-add-modal__required">*</span></span>
            <input id="meter-add-number" class="app-form-input" formControlName="meter_no" inputmode="numeric" (input)="sanitizeMeterNumber($event)" />
            @if (submitted && form.get('meter_no')?.invalid) { <section class="app-form-error">Meter Number is required and must contain digits only.</section> }
          </label>
          <label class="app-form-field" for="meter-add-manufacturer">
            <span class="app-form-label">Manufacturer Name</span>
            <input id="meter-add-manufacturer" class="app-form-input" formControlName="mfr_name" />
          </label>
          <label class="app-form-field" for="meter-add-type">
            <span class="app-form-label">Meter Type <span class="meter-add-modal__required">*</span></span>
            <select id="meter-add-type" class="app-form-select" formControlName="meter_type">@for(type of types; track type.value){<option [value]="type.value">{{ type.label }}</option>}</select>
          </label>
          <label class="app-form-field" for="meter-add-mf-value">
            <span class="app-form-label">MF Value</span>
            <input id="meter-add-mf-value" class="app-form-input" type="number" step="any" formControlName="mf_value" />
          </label>
        </div>
      </div>
      <div class="manage-generator-modal__footer">
        <button type="button" class="app-button app-button--secondary" (click)="closed.emit()">Cancel</button>
        <button type="submit" class="app-button app-button--primary">Save</button>
      </div>
    </form>
  </dialog>
</div>
